import * as React from 'react';
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';


import DateRangeInput from '../DateRangeInput';
import MultiSelectCheckbox from '../MultiSelectCheckbox';
import SelectRadioGroup from '../SelectRadioGroup';
import { ROUTE_LABEL, SINGLE_DAY_ROUTE } from '../../../utils/recommendationQuiz';

const SearchableSelectDropdown = ({ options, label, value, handleChange }) => {
  return (
    <Autocomplete
      name="location"
      id="searchable-select-dropdown"
      options={options}
      value={value}
      onChange={handleChange}
      renderInput={(params) => <TextField {...params} label={label} />}
      variant="standard"
    />
  );
};

export default function CustomizedRadios({ data, answers = {}, addAnswers }) {
  // `null`, not `''` — MUI treats an empty string as a value that is not in
  // the option list and warns. This was previously never set at all, so the
  // picker cleared itself visually the moment a destination was chosen.
  const [location, setLocation] = React.useState(null);

  /**
   * Answers live in the parent, not here.
   *
   * This component is remounted-in-place as the quiz advances — same element,
   * changing `data` — so a local copy of the answers used to accumulate across
   * steps and shadow the parent's. Merging into the `answers` prop keeps one
   * copy of the truth, which matters now that the route branches the quiz:
   * the date step below reads the route the traveller picked two steps back.
   */
  const merge = (patch) => addAnswers({ ...answers, ...patch });

  const handleLocation = (event, newValue) => {
    // Always written to `location`, whatever the question is called — the
    // itinerary page filters every listing on this field by that name.
    setLocation(newValue);
    merge({ location: newValue });
  };

  const handDate = (newValue) => {
    // Likewise `dates`. A range on a Holiday, a single date on a Day Activity.
    merge({ dates: newValue });
  };

  const handMultiSelect = (name, newValue) => {
    merge({ [name]: newValue });
  };

  /**
   * Options are stored as `{ value, label }` throughout. The destination
   * picker is the exception: it hands its raw selection straight to
   * `itinerary.location`, which is string-compared against `listing.location`,
   * so it has to be a list of plain strings.
   */
  const options = React.useMemo(() => (Array.isArray(data.options) ? data.options : []), [data.options]);
  const locationOptions = React.useMemo(() => options.map((o) => o.value), [options]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column'}}>
        <FormControl style={{ margin: '0 0 12px 0px'}}>
            <FormLabel style={{ fontSize: '18px', color: 'var(--vk-text-primary, #282C34)', marginBottom: '18px'}}>{data.question}</FormLabel>
            {/* The caption on these two is fixed rather than admin-editable:
                `data.label` is now the answer key, not a display string, and
                the question itself is already shown above. */}
            {data.type === "locationselect" && <SearchableSelectDropdown options={locationOptions} label="Select a location" value={location} handleChange={handleLocation} />}
            {data.type === "daterange" && <DateRangeInput selectRange={answers[ROUTE_LABEL] !== SINGLE_DAY_ROUTE} handleChange={handDate} />}
            {data.type === "multitagselect" && <MultiSelectCheckbox options={options} label={data.label} handleChange={handMultiSelect} />}
            {data.type === "textinput" && <TextField id="trip-name" label={data.question} variant="standard" onChange={(e) => handMultiSelect(data.label, e.target.value)} />}
            {data.type === "radiogroup" && <SelectRadioGroup options={options} label={data.label} handleChange={handMultiSelect} />}
        </FormControl>

    </div>
  );
}
